import React, { createContext, useContext, useState } from 'react';

const StateContext = createContext();

const initialState = {
  chat: false,
  cart: false,
  userProfile: false,
  userFaq: false,
  notification: false,
};

export const ContextProvider = ({ children }) => {
  const [screenSize, setScreenSize] = useState(undefined);
  const [currentColor, setCurrentColor] = useState('#03C9D7');
  const [isMobile, setIsMobile] = useState(false);
  const [zRenderMode, setZRenderMode] = useState('Horizontal');
  const [currentMode, setCurrentMode] = useState('Light');
  const [themeSettings, setThemeSettings] = useState(false);
  const [inventoryCount, setInventoryCount] = useState(0);
  const [associateCount, setAssociateCount] = useState(0);
  const [managerCount, setManagerCount] = useState(0);
  const [changeAssociate, setChangeAssociate] = useState('');
  const [elapsed, setElapsed] = useState(15 * 60 * 1000);
  const idleStorage = localStorage.getItem('idleLogout');
  const [idleLogout, setIdleLogout] = useState(idleStorage || '15');
  const [accordionExpanded, setAccordionExpanded] = useState(false);
  const [collapseConfiguration, setCollapseConfiguration] = useState(false);
  const [groups, setGroups] = useState(false);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [parentOrgs, setParentOrgs] = useState([]);
  const [limitPreference, setLimitPreference] = useState(0);

  // False to not display sidebar
  const [activeMenu, setActiveMenu] = useState(false);
  const [isClicked, setIsClicked] = useState(initialState);
  const [aiType, setAIType] = useState('');
  const [patientid, setPatientId] = useState('');

  const [activeLogin, setActiveLogin] = useState(false);
  const [amapActive, setAmapActive] = useState(false);
  const [boss, setBoss] = useState(false);
  const [loggedIn, setLoggedIn] = useState(false);

  const setMode = (e) => {
    setCurrentMode(e.target.value);
    localStorage.setItem('themeMode', e.target.value);
  };

  const setColor = (color) => {
    setCurrentColor(color);
    localStorage.setItem('colorMode', color);
  };

  const handleClick = (clicked) => setIsClicked({ ...initialState, [clicked]: true });

  return (
    // eslint-disable-next-line react/jsx-no-constructed-context-values
    <StateContext.Provider value={{
      currentColor,
      currentMode,
      activeMenu,
      screenSize,
      setScreenSize,
      isMobile,
      setIsMobile,
      zRenderMode,
      setZRenderMode,
      handleClick,
      isClicked,
      initialState,
      setIsClicked,
      aiType,
      setAIType,
      patientid,
      setPatientId,
      setActiveMenu,
      setCurrentColor,
      setCurrentMode,
      setMode,
      setColor,
      themeSettings,
      setThemeSettings,
      activeLogin,
      setActiveLogin,
      amapActive,
      setAmapActive,
      inventoryCount,
      setInventoryCount,
      associateCount,
      setAssociateCount,
      managerCount,
      setManagerCount,
      boss,
      setBoss,
      changeAssociate,
      setChangeAssociate,
      loggedIn,
      setLoggedIn,
      elapsed,
      setElapsed,
      idleLogout,
      setIdleLogout,
      collapseConfiguration,
      setCollapseConfiguration,
      accordionExpanded,
      setAccordionExpanded,
      groups,
      setGroups,
      isDialogOpen,
      setIsDialogOpen,
      parentOrgs,
      setParentOrgs,
      limitPreference,
      setLimitPreference,
    }}
    >
      {children}
    </StateContext.Provider>
  );
};
export const useStateContext = () => useContext(StateContext);
